module.exports = __webpack_public_path__ + "img/InspirationArticle.3a7cc822.png";